<div class="calendario small">

  <div class="header">
    {{ fechaDate | date:'MMMM yyyy' | titlecase }}
  </div>

  <div class="dias-semana">
    <div *ngFor="let d of ['L','M','X','J','V','S','D']">
      {{ d }}
    </div>
  </div>

  <div class="semana" *ngFor="let semana of semanas">
    <div 
      class="dia"
      *ngFor="let dia of semana; let i = index"
      [ngClass]="{
        'vacio': dia === null,
        'hoy rounded': dia === diaHoy && mes === mesHoy && anio === anioHoy,
        'text-secondary': esDiaPasado(dia),
        'text-iguau': esFinDeSemana(i),
        'seleccionado rounded': dia === diaSeleccionado,
      }">

      {{ dia !== null ? dia : '' }}

    </div>
  </div>

</div>